import { connect } from 'react-redux';
import { motion } from "framer-motion";
import React from "react";
import { withTranslation, Trans } from "react-i18next";
import WikiNavBar from "components/Navbars/WikiNavBar.jsx";
import features from '../../variables/features';
import { ingameCommands, discordCommands } from '../../variables/wiki';
import { setBeacon } from '../../redux/actions/rLink.action';
import { getInit } from '../../redux/actions/init.action';
import {
    Nav,
    NavItem,
    NavLink,
    Card,
    CardBody,
    Modal,
    ModalBody,
    Row,
    Col,
    Button
  } from "reactstrap";
class Wiki extends React.Component {
  constructor(props) {
    super(props);
    this.addBotToTheDiscordRef = React.createRef();
    this.faqRef = React.createRef();
    this.extensionInstallationRef = React.createRef();
    this.pairBotWithRustServerRef = React.createRef();
    this.ingameCommandsRef = React.createRef();
    this.discordCommandsRef = React.createRef();
    this.state = {
        scrollPosition: 0,
        modalOpen: false,
        modalImg: [],
        modalImgStep: 0
    }
    this.featuresRef = [];
    features.map(f => {
        return this.featuresRef[f.key] = React.createRef();
    })
  }
  componentDidMount = async () => {
    await this.props.getInit();
    setTimeout(() => {
      const beacon = document.getElementById(typeof(chrome) == "object" ? "chromeAddon" : "mozAddon");
      const isPresent = beacon && beacon.innerHTML === "1.0.1";
      this.props.setBeacon(isPresent);
    }, 250);
    window.addEventListener('scroll', this.listenToScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.listenToScroll)
  }
  listenToScroll = () => {
    this.setState({
        scrollPosition: document.body.scrollTop || document.documentElement.scrollTop,
    })
  }
  renderMsg = (msg, type) => {
      return (
        <Card className="drawMsg">
            <CardBody className={type}>
                <Trans i18nKey={`wiki:${msg}`} components={{italic: <i /> }}/>
            </CardBody>
        </Card>)
  }
  closeModal = () => {
      this.setState({
        modalOpen: false,
        modalImg: false,
        modalImgStep: 0
      });
  }
  getPlan = (plan) => {
      if (plan === 2) return 'regular';
      else if (plan === 3) return 'chad';
      else return 'light';
  }
  /*isInView = (elm) => {
      var scrollPos = this.state.scrollPosition;
      var elmTop = (elm && elm.current && elm.current.offsetTop) ? elm.current.offsetTop : 0;
      var elmHeight = (elm && elm.current && elm.current.offsetHeight) ? elm.current.offsetHeight : 0;
      var elmBottom = elmTop + elmHeight;
      if (elmTop === 0 || elmHeight === 0) return false;
      return ((scrollPos >= elmTop) && (scrollPos <= elmBottom));
  }*/
  isInView = (elm) => {
    if (!elm || !elm?.current?.getBoundingClientRect()) return false;
    var rect = elm.current.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
  }
  openImg = (array) => {
    this.setState({
        modalOpen: true,
        modalImg: array,
    });
  }
  changeImg = (plus) => {
    this.state.modalImg[this.state.modalImgStep + plus] && this.setState({
        modalImgStep: this.state.modalImgStep + plus
    });
  }
  render() {
    return (
        <>
            <Modal className="wikiModal modal-dialog-images" centered={true} isOpen={this.state.modalOpen} animation={false} fade={false} toggle={this.closeModal}>
                <ModalBody className="text-center">
                    <Row>
                        {this.state.modalImg.length > 1 && <Col xs="2" className="wikiModalArrow" onClick={() => this.changeImg(-1)}>
                            {this.state.modalImg[this.state.modalImgStep - 1] && <i className="imageWikiBtn tim-icons icon-minimal-left"/>}
                        </Col>}
                        <Col xs={this.state.modalImg.length > 1 ? "8" : "12"} onClick={() => this.closeModal()}>
                            <img alt="logo" src={`https://rustlink.io/static/media/${this.state.modalImg[this.state.modalImgStep]}.png`}></img>
                        </Col>
                        {this.state.modalImg.length > 1 && <Col xs="2" className="wikiModalArrow" onClick={() => this.changeImg(1)}>
                            {this.state.modalImg[this.state.modalImgStep + 1] && <i className="imageWikiBtn tim-icons icon-minimal-right"/>}
                        </Col>}
                    </Row>
                </ModalBody>
            </Modal>
            <WikiNavBar/>
            <div class="wrapper">
                <div className="docs-sidebar">
                    <motion.div initial={{ opacity: 0.5, x: -100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                        <Nav className="navSideBar">
                            <NavItem className="section-title">
                                <NavLink href="#RustLink">RustLink</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.isInView(this.faqRef) ? 'surligned' : ''} href="#faq">{this.props.t(`FAQ.faq`)}</NavLink>
                            </NavItem>
                            <NavItem className="section-title">
                                <NavLink href="#setupRL">{this.props.t(`installBot.botInstallation`)}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.isInView(this.extensionInstallationRef) ? 'surligned' : ''} href="#setupExtension">{this.props.t(`installBot.extensionInstallation`)}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.isInView(this.addBotToTheDiscordRef) ? 'surligned' : ''} href="#addBot">{this.props.t(`installBot.addBotToTheDiscord`)}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.isInView(this.pairBotWithRustServerRef) ? 'surligned' : ''} href="#linkRust">{this.props.t(`installBot.pairBotWithRustServer`)}</NavLink>
                            </NavItem>
                            <NavItem className="section-title">
                                <NavLink href="#commands">{this.props.t(`Commands.commands`)}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.isInView(this.ingameCommandsRef) ? 'surligned' : ''} href="#commandsIG">{this.props.t(`Commands.ingameCommands`)}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={this.isInView(this.discordCommandsRef) ? 'surligned' : ''} href="#commandsDiscord">{this.props.t(`Commands.discordCommands`)}</NavLink>
                            </NavItem>
                            <NavItem className="section-title">
                                <NavLink href="#features">{this.props.t(`Features.features`)}</NavLink>
                            </NavItem>
                            {features.map(f => {
                                return !f.wikiHide ? (<>
                                    <NavItem>
                                        <NavLink className={this.isInView(this.featuresRef[f.key]) ? 'surligned' : ''} href={`#feature-${f.key}`}>{this.props.t(`plans:${f.key}.title`)}</NavLink>
                                    </NavItem>
                                </>) : (<></>)}
                            )}
                        </Nav>
                    </motion.div>
                </div>
                <motion.div initial={{ opacity: 0.5, x: 100 }} animate={{ opacity: 1, x: 0, transition: { duration: 0.5 } }}>
                    <div class="docs-content">
                        <div className="docs-section">
                            <article class="docs-article" id="RustLink">
                                    <h1 className="title">RustLink {this.props.t('wiki')}</h1>
                                        <section class="docs-intro">
                                            <p>{this.props.t('Intro.text1')}</p>
                                            <p>{this.props.t('Intro.text2')}</p>
                                        </section>
                            </article>
                            <article class="docs-article" id="faq" ref={this.faqRef}>
                                    <h2 className="subTitle">{this.props.t('FAQ.faq')}</h2>
                                    {
                                        [...Array(9)].map((x, i) => {
                                            return(<>
                                                <div className="question">{this.props.t(`FAQ.q${i+1}`)}</div>
                                                <div className="answer">{this.props.t(`FAQ.a${i+1}`)}</div>
                                            </>)
                                        })
                                    }
                            </article>
                        </div>

                        <div className="docs-section">
                            <article class="docs-article" id="setupRL">
                                    <h2 className="subTitle">{this.props.t(`installBot.botInstallation`)}</h2>
                                        <section class="docs-intro">
                                            <p>{this.props.t(`installBot.intro`)} : <a href="https://www.youtube.com/watch?v=pTOrcpzk4S8" rel="noreferrer" target="_blank">https://youtu.be/pTOrcpzk4S8</a>.</p>
                                        </section>
                            </article>
                            <article class="docs-article" id="setupExtension" ref={this.extensionInstallationRef}>
                                    <h3 className="subTitle">{this.props.t(`installBot.extensionInstallation`)}</h3>
                                        <ul>
                                            <li><Button className="installAddon" color="info" onClick={()=> window.open(typeof(chrome) == "object" ? "/chrome" : "/mozilla", "_self")}>
                                                {this.props.t('home:getstarted.install')}
                                            </Button></li>
                                            <li>{this.props.t(`installBot.extensionStep`)}</li>
                                        </ul>
                            </article>
                            <article class="docs-article" id="addBot" ref={this.addBotToTheDiscordRef}>
                                    <h3 className="subTitle">{this.props.t(`installBot.addBotToTheDiscord`)}</h3>
                                        {this.renderMsg(`installBot.addBotToTheDiscordAlert1`, 'warning')}
                                        <ul>
                                            {
                                                [...Array(5)].map((x, i) => {
                                                    //return(<li>{this.props.t(`installBot.addBotToTheDiscordStep${i+1}`)}</li>)
                                                    return(<li><Trans i18nKey={`wiki:installBot.addBotToTheDiscordStep${i+1}`} components={{bold: <strong /> }}/></li>)
                                                })
                                            }
                                        </ul>
                                        {this.renderMsg(`installBot.addBotToTheDiscordAlert2`, 'info')}
                            </article>
                            <article class="docs-article" id="linkRust" ref={this.pairBotWithRustServerRef}>
                                    <h3 className="subTitle">{this.props.t(`installBot.pairBotWithRustServer`)}</h3>
                                        <p><Trans i18nKey={`wiki:installBot.pairBotWithRustServerIntro`} components={{bold: <strong /> }}/></p>
                                        <ul>
                                            {
                                                [...Array(4)].map((x, i) => {
                                                    return(<li>{this.props.t(`installBot.pairBotWithRustServerStep${i+1}`)}</li>)
                                                })
                                            }
                                        </ul>
                            </article>
                        </div>

                        <div className="docs-section">
                            <article class="docs-article" id="commands">
                                <h2 className="subTitle">{this.props.t(`Commands.commands`)}</h2>
                                <section class="docs-intro">
                                    <p>{this.props.t(`Commands.intro`)}</p>
                                </section>
                            </article>
                            <article class="docs-article" id="commandsIG" ref={this.ingameCommandsRef}>
                                <h3 className="subTitle">{this.props.t(`Commands.ingameCommands`)}</h3>
                                <ul>
                                    {ingameCommands.map(c => {
                                        return (
                                                <>
                                                    <li><div className="feature">{this.props.ingame.prefix}{c.cmd} {c.plan > 1 && <div className={`planNeeded plan${c.plan}`}>{this.props.t(`plans:title.${this.getPlan(c.plan)}`)}</div>}{c.img.length > 0 && <i className="imageWikiBtn tim-icons icon-camera-18" onClick={() => this.openImg(c.img)}/>}</div></li>
                                                    <div className="command">{this.props.t(c.translate)}</div>
                                                </>
                                        )}
                                    )}
                                </ul>
                            </article>
                            <article class="docs-article" id="commandsDiscord" ref={this.discordCommandsRef}>
                                <h3 className="subTitle">{this.props.t(`Commands.discordCommands`)}</h3>
                                <ul>
                                    {discordCommands.map(c => {
                                        return (
                                                <>
                                                    <li><div className="feature">/{c.cmd} {c.plan > 1 && <div className={`planNeeded plan${c.plan}`}>{this.props.t(`plans:title.${this.getPlan(c.plan)}`)}</div>}{c.img.length > 0 && <i className="imageWikiBtn tim-icons icon-camera-18" onClick={() => this.openImg(c.img)}/>}</div></li>
                                                    <div className="command"><Trans i18nKey={`wiki:${c.translate}`} components={{bold: <strong /> }}/></div>
                                                </>
                                        )}
                                    )}
                                </ul>
                            </article>
                        </div>
                        <div className="docs-section">

                            <article class="docs-article" id="features">
                                <h2 className="subTitle">{this.props.t(`Features.features`)}</h2>
                                <section class="docs-intro">
                                    <p>{this.props.t(`Features.intro`)}</p>
                                </section>
                            </article>

                            {features.map(f => {
                                return !f.wikiHide ? (<>
                                    <article class="docs-article" id={`feature-${f.key}`} ref={this.featuresRef[f.key]}>
                                        <h3 className="subTitle">{this.props.t(`plans:${f.key}.title`)}</h3>
                                        {f.sub && f.sub.map(s => {
                                            return(<>
                                                <ul>
                                                    <li> <div className="feature">{this.props.t(`plans:${s.key}.title`)} {s.plan > 1 && <div className={`planNeeded plan${s.plan}`}>{this.props.t(`plans:title.${this.getPlan(s.plan)}`)}</div>}{s.img && s.img.length > 0 && <i className="imageWikiBtn tim-icons icon-camera-18" onClick={() => this.openImg(s.img)}/>}</div></li>
                                                    <div className="command">{this.props.t(`plans:${s.key}.desc`)}</div>
                                                </ul>
                                            </>)
                                        })
                                            
                                        }
                                    </article>
                                </>) : (<></>)}
                            )}
                        </div>
                        
                    </div>
                </motion.div>
            </div>
        </>
    )};
};

const mapDispatchToProps = {
    setBeacon,
    getInit
};

const mapStateToProps = (state) => {
    const { ingame } = state.settings;
    return { ingame };
};

export default withTranslation(['wiki', 'common', 'plans', 'home'])(connect(mapStateToProps, mapDispatchToProps)(Wiki));